import axios from 'axios';

import {
  TOKEN_TABLEAU,
  SYSTEM_TOAST_ERROR_MESSAGE
} from './types';

import { serverEndPoint } from './Utils';

export const authTableau = (cpf) => {
  return async (dispatch, getState) => {
    try {
   
      const state = getState();
      if (state.tableau.tableau) {
        const response = await axios.get(`${serverEndPoint}/apps/tokenVerification/${state.tableau.tableau}`)
        const {isValid} = response.data
        if (isValid) {
          return;
        }
      }

      const response = await axios.get(`${serverEndPoint}/apps/generateToken/${cpf}`);
      const { token } = response.data  
  
      await dispatch({
        type: TOKEN_TABLEAU,
        payload: token,
      });

    } catch (err) {
      dispatch({
        type: SYSTEM_TOAST_ERROR_MESSAGE,
        payload: 'Erro na autenticação com a visão do tableau',
      });
    }
  };
};


